import { ComponentStyleConfig } from '@chakra-ui/react'

export const Card: ComponentStyleConfig = {
  baseStyle: {
    container: {
      boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)',
    },
  },
}
